exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a {\r\n    margin-left: 25px;\r\n    font-size: 20px;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    color: #7a7a7a;\r\n    font-family: 'Corbel';\r\n}\r\n\r\na:hover {\r\n    color: #272727;\r\n}\r\n\r\nimg {\r\n    height: 40px;\r\n}\r\n\r\ndiv {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding: 0;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.selected {\r\n    color: #90acb9;\r\n}\r\n\r\n.static-nav {\r\n    top: -50px;\r\n    -webkit-transition: linear;\r\n    transition: linear;\r\n}\r\n\r\n.top-nav {\r\n    margin: 0;\r\n    padding: 10px 0 5px 0;\r\n    position: fixed;\r\n    top: 0;\r\n    z-index: 300;\r\n    background-color: white;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n    -webkit-transition: 200ms ease-in;\r\n    transition: 200ms ease-in;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.css
// module id = 745
// module chunks = 1